module.exports = __webpack_public_path__ + "img/5.63f0d870.jpg";